import React  from 'react';

const Button = ({text, onClick}: {text: string, onClick: any}) => {
    return (
        <button onClick={onClick} className="min-w-[150px] lg:min-w-[250px] border border-[1px] border-white flex flex-col items-center justify-center uppercase text-white text-xs lg:text-base font-untitledSans px-[25px] lg:px-[50px] py-[4px] lg:py-[8px] whitespace-nowrap">{text}</button>
    );
};

export default Button;
